var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.806 7.458H2.062c.005-.41.037-.763.096-1.06.064-.3.171-.571.321-.813.155-.242.36-.48.616-.718.214-.191.4-.374.56-.547.16-.173.285-.35.376-.533a1.4 1.4 0 0 0 .137-.622c0-.264-.041-.483-.123-.656a.833.833 0 0 0-.356-.404 1.145 1.145 0 0 0-.587-.136 1.18 1.18 0 0 0-.547.13c-.169.082-.308.21-.417.382-.105.174-.16.401-.164.684H-.01c.014-.624.157-1.14.43-1.545A2.48 2.48 0 0 1 1.537.71c.465-.2.987-.3 1.566-.3.638 0 1.184.105 1.64.315.456.205.805.508 1.046.909.242.396.362.88.362 1.449 0 .396-.077.75-.232 1.06-.155.305-.358.59-.608.854-.251.264-.527.538-.828.82-.26.233-.437.477-.533.732a2.818 2.818 0 0 0-.143.909ZM1.857 9.57c0-.291.1-.533.301-.724.2-.196.47-.294.807-.294.333 0 .6.098.8.294a.949.949 0 0 1 .307.724.955.955 0 0 1-.307.718c-.2.196-.467.294-.8.294-.337 0-.606-.098-.807-.294a.965.965 0 0 1-.3-.718Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.ee0421c56227c40b124bea3694f268c3.svg";
export { ForwardRef as ReactComponent };